import { render, staticRenderFns } from "./HCSOP.vue?vue&type=template&id=36cd2101"
import script from "./HCSOP.vue?vue&type=script&lang=js"
export * from "./HCSOP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports